module.exports = __webpack_public_path__ + "img/ordinary-membership.83552409.png";